"use client";

import { cn } from "@/lib/utils";

export default function ProductUpdateDescription({
  html = "",
  collapsed = false,
  previewLength = 220,
  className,
  onImageClick,
}) {
  const previewLines = previewLength <= 120 ? 2 : previewLength <= 220 ? 4 : 6;
  const content = html || "<p>No description provided.</p>";

  // Images inside the description (step-by-step screenshots) open in the
  // caller's preview when clicked.
  const handleClick = (event) => {
    const image = event.target;
    if (!onImageClick || image?.tagName !== "IMG") return;

    onImageClick({ url: image.currentSrc || image.src, title: image.alt });
  };

  if (collapsed) {
    return (
      <div
        className={cn(
          "min-w-0 max-w-full overflow-hidden text-sm leading-6 text-neutral-600 break-words",
          "[display:-webkit-box] [-webkit-box-orient:vertical]",
          "[&_p]:mb-2 [&_ul]:mb-2 [&_ol]:mb-2 [&_blockquote]:mb-2",
          "[&_p]:break-words [&_li]:break-words [&_a]:break-all",
          "[&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5",
          "[&_a]:text-sky-700 [&_a]:underline [&_img]:hidden",
          className,
        )}
        style={{ WebkitLineClamp: previewLines }}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }

  return (
    <div
      className={cn(
        "min-w-0 max-w-full overflow-hidden text-sm leading-6 text-neutral-700 break-words",
        "[&_p]:mb-2 [&_ul]:mb-2 [&_ol]:mb-2 [&_blockquote]:mb-2",
        "[&_p]:break-words [&_li]:break-words [&_a]:break-all",
        "[&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5",
        "[&_a]:text-sky-700 [&_a]:underline",
        onImageClick && "[&_img]:cursor-zoom-in",
        className,
      )}
      onClick={handleClick}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}
